module.exports = __webpack_public_path__ + "res/media/profile_img_male02.4d86be5f.png";